import React from "react";
import Card from "react-bootstrap/Card";
import { AiOutlineArrowRight } from "react-icons/ai";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0" data-aos="zoom-in">
          <p style={{ fontSize: "15px", fontFamily: "Roboto Slab", textAlign: "justify" }}>
            I'm Sourabh Kumar, I am from <i className="primary-header" > Bihar ( Jamui ),</i> I started my career as a<strong className="primary-header"> Backend developer </strong> from <strong className="primary-header"> May 2022. </strong>
            <br />
            I'm passionate about creating efficient and effective backend systems that contribute to exceptional user experiences.
          </p>
          <ul>
            <li className="about-activity">
              <AiOutlineArrowRight /> Watching movies
            </li>
            <li className="about-activity">
              <AiOutlineArrowRight /> Playing Games
            </li>
            <li className="about-activity">
              <AiOutlineArrowRight /> Traveling
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
